import { render, staticRenderFns } from "./StoreSwitcher.vue?vue&type=template&id=f03e6984&"
import script from "./StoreSwitcher.vue?vue&type=script&lang=js&"
export * from "./StoreSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports